import { Component, Input } from '@angular/core';
import { AvailableServices } from '@vendasta/integrations';

@Component({
  selector: 'meeting-scheduler-connect-with-zoom-button',
  templateUrl: './connect-with-zoom-button.component.html',
  styleUrls: ['./connect-with-zoom-button.component.scss'],
  standalone: false,
})
export class ConnectWithZoomButtonComponent {
  @Input() serviceKey: string;
  public readonly zoom = AvailableServices.ZOOM;
}
